import React from 'react'

const dalat = {
    id: 'dalat',
    type: 'post',
    countryId: 'seAsia',
    title: 'Surprised by Theme Parks in Dalat',
    longDate: 'December 30, 2018',
    month: 'Dec',
    date: '30',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/dalatcover.jpg',
    content: [
        {
            text: (
                <div>Dalat is less than an hour away from Saigon by air, and with its location in the mountains, main industry of flower production, and colder weather, it was a great weekend getaway for us when we were craving a dose of nature.</div>
            )
        },
        {
            text: (
                <div>We flew in on a Saturday morning and had three full days in the area, which was a good amount of time. Unfortunately, I had a 24-hour sickness on our third day and wasn't up to much exploration, but even with that we managed to see nearly everything on our list from a motorbike. Dalat surprised me in that I expected the nature sights to be more... naturey. Two of the sights we visited, Datanla Waterfall and the Valley of Love, turned out to be mini theme parks on arrival. But we had a blast goofing around at them, and embraced the fact that everything has been maximized for photo opportunities these days. Scroll below for a great series of Peter posing with some of the more ridiculous photo opportunities!</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/dalatfarms.jpg'
        },
        {
            header: 'Sights in the City'
        },
        {
            subheader: 'Crazy House'
        },
        {
            text: (
                <div>One of the major attractions in Dalat is the Crazy House, a <a href="https://www.google.com/search?q=gaudi+architecture">Gaudí-inspired</a> building that doubles as a guesthouse and an hour of entertainment wandering around winding staircases. The walls come in all sorts of organic shapes, none of them with straight edges or right angles, and many are made of mosaiced cement. The staircases and sky walkways wind around trees – some real, some extensions of the building – and pick a maze-like path around the property. It's kooky and quite fun to explore and search for hidden nooks. </div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/petercrazyhouse.jpg'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/crazyhouse1.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/crazyhouse2.jpg']
        },
        {
            subheader: 'Linh Phuoc Pagoda'
        },
        {
            text: (
                <div>Building off the unique architecture of Crazy House, Linh Phuoc Pagoda is colorful, intricate, and covered in mosaics. The dragon temple is made of 12,000 bottles, and there are far too many details to take in in one visit. We didn't stay long or enter the temple, but there's free entry and it's well worth the visit to see.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/chualinhphuoc.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/chualinhphuoc2.jpg'
        },
        {
            subheader: 'Xuan Huong Lake and Cong Vien Yersin Park'
        },
        {
            text: (
                <div>Dalat is a pretty small city, and it's centered around a beautiful lake with a few parks surrounding it. Cong Vien Yersin park acts as a town square, with an amphitheater and underground shopping center. We walked around the lake and parks in the daytime, but also had a great opportunity to go to a nighttime event there: the livestream of the final AFF Cup elimination game between Vietnam and Malaysia!</div>
            )
        },
        {
            text: (
                <div>The AFF Cup is a soccer tournament among Asian countries, and they have elimination rounds for each region. Vietnam was poised to win the Southeast Asian tournament, and needed this final win to cinch it. Since it's likely that they'll get knocked out immediately when up against the other finalists, this elimination round was basically their version of the World Cup.</div>
            )
        },
        {
            text: (
                <div>The town broadcast the game on a massive screen in the park for free, and we grabbed seats and street food. Unluckily, it rained the entire time, and we were pretty cold. Also unluckily, the street food we tried, Dalat pizza (a crepe-like item famous in the city), was really bad. So, I spent most of the second half inside the mall warming up and getting real food, then emerged again for the winning celebrations. I guess it was unusual to have American tourists dancing and jumping around at a Vietnamese soccer game, because several people took photos and videos of us! Despite the rain, it was really cool to be part of the event. For hours afterward, cars and motorbikes clogged the city streets honking, singing, and waving Vietnam flags.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/dalatnight.jpg'
        },
        {
            header: 'Nature Activities'
        },
        {
            subheader: 'Cau Dat Tea Farm'
        },
        {
            text: (
                <div>A friend who camps in Dalat frequently recommended a trip to the Cau Dat Tea Farm an hour outside of Dalat. We thought it would be a little off the beaten path since we hadn't heard of it, but little did we know this was a top Instagram photoshoot spot in Dalat! The tea terraces are beautiful: kind of like rice terraces, and bright green. We wandered along the path and enjoyed the scenery, and of course I did a photoshoot with <a href="https://www.instagram.com/astroabroad/">Astro</a>. We ordered green tea from a tea shop repurposed from an old warehouse and sat outside for a bit, while a cute 5 year-old Vietnamese boy tried to talk to us. He was very confused that we didn't speak Vietnamese.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/caudat.jpg'
        },
        {
            subheader: 'Datanla Waterfall'
        },
        {
            text: (
                <div>Surprise theme park #1! The waterfall is located 4 kilometers from the entrance, and instead of a hiking path, they built a roller coaster! The carts are self-powered and don't go terribly fast, so even though this was the afternoon I was sick with a bad headache, it was really fun to zoom through the forest. The waterfall itself wasn't terribly large, but to get to the cafe at the top, there was an elevator and a cable car. Walking is really not a thing here.</div>
            )
        },
        {
            subheader: 'Prenn Waterfall'
        },
        {
            text: (
                <div>There are several other waterfalls in the Dalat area, the most-visited of which is Elephant Waterfall, but we only had time for one from our list. We stopped by Prenn Waterfall shortly before it closed at 5 p.m. and this lovely spot nearly to ourselves. Even though this one didn't have quite as much tourist attraction infrastructure built around it, they still paved the short walkway along the pond bank, and had an area for riding elephants and ostriches.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/prenn.jpg'
        },
        {
            header: 'The Valley of Love'
        },
        {
            text: (
                <div>The Valley of Love deserves its own category, because it was unlike anything I've ever visited. Ostensibly, it's a flower garden where you can see the flower beds and greenhouses – Dalat is Vietnam's premier flower-growing area and ships them around the country. What we actually found included: a mini-motorbike racetrack; a heart-shaped maze with a gazebo outlook in the middle; many, MANY heart-shaped flower trellises placed strategically around the grounds for photo opportunities; a vintage train; a shuttle to take you to two areas of the park full of statues and other structures nestled among the flowers; and finally, the flower beds, which no one else visited. It was nuts! Please enjoy a series of photos that hopefully capture the hilarity.</div>
            )
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/vol1.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/vol2.jpg']
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/vol3.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/vol4.jpg']
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/vol5.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/vol6.jpg']
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/vol7.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/vol8.jpg']
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/vol9.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/vol10.jpg']
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/vol11.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/vol12.jpg']
        },
        {
            text: (
                <div>While waiting in line in part of the park, a group of young girls saw us and started giggling, then talking to us. Their parents saw and asked if they could take a photo of us with the kids – I really wish I had a copy, because we look like we've gone full Brangelina (R.I.P.) In the big cities in Vietnam kids are used to seeing white foreigners, but I think it's less so in some of the other areas – they were so much more fascinated with us in Dalat than Saigon or Hanoi.</div>
            )
        },
        {
            header: "A Few Thoughts on Dalat's Nature Attractions"
        },
        {
            text: (
                <div>There's definitely a big cultural difference we've noticed in Vietnam, in that most people rarely walk places. In the cities, people motorbike everywhere; the streets are literally built to accommodate bikes parking on the sidewalks (thereby blocking them), and if it's not a motorbike blocking the path, it's trash, someone's restaurant, a fruit stand, a car, construction – you name it. Outside of District 1 in Saigon, we're often the only people walking around. Outside of cities, some people do hike and camp, but it's not common and all of the Dalat attractions were built to minimize the walking involved. In addition, the nature attractions are not left as simply nature - they're accompanied by gaudy development.</div>
            )
        },
        {
            text: (
                <div>I also find it pretty funny, and odd, that the photo spots are so blatantly constructed for that purpose – similar to Ko Phi Phi (scroll to the end of <a href="https://worldofwander.app/post/koh-yao">this post</a>), where the viewpoint had gigantic letters spelling 'VIEWPOINT 1' (I guess so that everyone who saw the photo would know exactly where you were??) But Peter pointed out that with everyone Instagramming constantly these days, Asia and Asian tourists were basically just ahead of the curve in making a photo opportunity out of everything. He has a point!</div>
            )
        },
        {
            header: 'Where to Stay if You Go'
        },
        {
            text: (
                <div>We stayed at a beautiful new Airbnb, which was extremely cozy and what I'll term "hipster-rustic" (lots of wooden pallets and glass jars with tea in the kitchen.) I would highly recommend it, and there's a great Italian restaurant just a few doors down for a great neighborhood dinner.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/dalat/airbnb.jpg'
        },
        {
            text: (
                <div>The friend who frequently visits Dalat also sent us this list of recommendations:
                    <ul>
                        <li>Zen Cafe Lakeside, Phường 4, Thành phố Đà Lạt, Lâm Đồng</li>
                        <li>Émai Dalat Restaurant, Cafe & Homestay, 1 Thi Sách, Phường 6, Thành phố Đà Lạt, Lâm Đồng</li>
                        <li>Củi Homestay, 79 Triệu Việt Vương, Phường 3, Thành phố Đà Lạt, Lâm Đồng</li>
                        <li>Stop and Go Hotel, 88 Lý Tự Trọng, Phường 2, Thành phố Đà Lạt, Lâm Đồng</li>
                    </ul>
                </div>
            )
        }
    ]
}

export default dalat


// WEBPACK FOOTER //
// ./src/Posts/Content/Dalat.js